import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerBodyStyleAll: [],
  insurerBodyStyle: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerBodyStyleSlice = createSlice({
  name: "insurerBodyStyle",
  initialState,
  reducers: {
    setInsurerBodyStyleAll: (state, action) => {
      state.insurerBodyStyleAll = action.payload;
    },
    setInsurerBodyStyle: (state, action) => {
      state.insurerBodyStyle = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerBodyStyleAll,
  setInsurerBodyStyle,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerBodyStyleSlice.actions;

export default insurerBodyStyleSlice.reducer;
